import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from 'hooks/useAppDispatch'
import { getLatestNews } from 'actions/news.action'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'

export interface LatestNewsProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const useLatestNews = (props: LatestNewsProps) => {
  const dispatch = useAppDispatch()
  const latestNews = useSelector(
    (state: RootState) => state.news.latestNewsData
  )

  useEffect(() => {
    if (!latestNews) dispatch(getLatestNews())
  }, [latestNews])
  return {
    ...props,
    latestNews,
  }
}
